module.exports = __webpack_public_path__ + "img/sms.21394de7.jpg";